




























































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { Button, Card, Input, Option, Select } from 'element-ui';
import CustomerCreate from '@/components/modals/customer/CustomerCreate.vue';
import NavBar from '@/components/layout/NavBar.vue';

import Pagination from '@/mixins/pagination';

import fetchCustomerOrgs from '@/graphql/queries/FetchCustomerOrganizations.gql';

import { CustomerOrganizationFilterEnum } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    CustomerCreate,
    NavBar,
    'el-button': Button,
    'el-card': Card,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  },
  apollo: {
    customers: {
      query: fetchCustomerOrgs,
      debounce: 300,
      fetchPolicy: 'network-only',
      variables() {
        return {
          customerOrganizationArgs: {
            name: this.searchText,
            sorting: this.sorting
          },
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          },
          filter: this.filter
        };
      },
      update(data) {
        this.totalCount = data ? data.customerOrganizationsPagination.totalCount : 0;
        return data && data.customerOrganizations;
      }
    }
  }
})
export default class CustomersList extends Mixins(Pagination) {
  filter: CustomerOrganizationFilterEnum = CustomerOrganizationFilterEnum.active;
  searchText = '';
  showModal = false;

  refresh() {
    this.$apollo.queries.customers.refetch();
  }
}
